<template>
  <Modal headerType="win" showFirework v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </Modal>
</template>

<script>
import Modal from './Modal';
export default {
  components: { Modal }
};
</script>
